var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportXml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 22.41,
    cy: 39.67,
    r: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M18.56 34.01l3.75-3.75 3.75 3.75M22.41 30.6v5.03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M11.19 12.43v-3.9a5.28 5.28 0 015.27-5.28h10.23M33.34 12.77V9.96M26.7 3.35l6.6 6.6M25.88 4.49v6.25h6.61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M9.86 17.22l4.78 6.89M14.64 17.22l-4.78 6.89M19.31 24.11v-6.89l3.43 3.45 3.49-3.45v6.89M31.36 17.22v6.89h3.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportXml);
export default __webpack_public_path__ + "static/media/importXML.01ac338fb1b6dbbffceeaccf68c0db89.svg";
export { ForwardRef as ReactComponent };